<!-- global-loading.component.html -->
@if (loadingService.isLoading()) {
  <!-- شريط التقدم العلوي -->
  <div class="top-progress-bar">
    <div class="top-progress-bar-inner"></div>
  </div>

  <!-- Overlay خفيف بسبينر في النص -->
  <div class="loading-overlay">
    <div class="loading-spinner">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}